// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
import notify from '../../utils/notify';
// css
import '../../styles/components/sources/ConfiguredItemForm.scss';

const MAX_CUSTOM_ITEMS = 5;


class CustomConfiguredItemBtn extends Component {
  constructor(props) {
    super(props);
  }

  addCustomConfiguredItem() {
    if (this.props.numCustomItems < MAX_CUSTOM_ITEMS) {
      const dsaId = this.props.dsa.id;
      const subareaId = this.props.subarea.id;
      this.props.createCustomConfiguredItem(dsaId, subareaId);
    } else {
      notify.info('You\'ve reached the max number of custom items.');
      this.setState({ maxCustomItems: true});
    }
  }

  renderCustomConfigurationItemBtn() {
    return (
      <Button
        loading={false}
        onClick={() => this.addCustomConfiguredItem()}
        primary
        label='Add Custom Configured Item'
      />
    );
  }

  render() {
    return (
      <div className='custom-configured-item'>
        { this.renderCustomConfigurationItemBtn() }
      </div>
    );
  }
}

CustomConfiguredItemBtn.propTypes = {
  dsa: PropTypes.object,
  subarea: PropTypes.object,
  numCustomItems: PropTypes.number,
  createCustomConfiguredItem: PropTypes.func
};

export default CustomConfiguredItemBtn;



// WEBPACK FOOTER //
// ./src/components/sources/CustomConfiguredItemBtn.js